import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

const getSmsMessage = async ({ smsMessageId }) => {
  try {
    const callable = functions.httpsCallable('getSmsMessage')
    const result = await callable({ smsMessageId })
    return { ok: true, data: result.data }
  } catch (error) {
    console.error('[getSmsMessage] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default getSmsMessage
